'use strict';
var $ = require('jquery');
var Backbone = require('backbone');
var PubSub = require('tscom-pubsub');

module.exports = Backbone.Model.extend({

    url: '',
    defaults: {
        firstName: '',
        lastName: '',
        username: '',
        dateOfBirth: '',
        emailVerified: false,
        guest: {},
        id: '',
        loggedIn: false
    },
    /**
     * Initialize OneID Model
     */
    initialize: function(attrs, options) {

        this.oid = null;
        this.clickedLogin = false;
        this.copyCms = options.copyCms;

        // override for CSS
        if(typeof options.cssOverride !== 'undefined' && options.cssOverride !== '') {
            this.cssOverride = options.cssOverride;
        } else {
            this.cssOverride = 'https://assets-us.votenow.tv/projects/one-id/styles.css';
        }

        // override for responder page
        if(typeof options.responderPage !== 'undefined' && options.responderPage !== '') {
            this.responderPage = options.responderPage;
        } else {
            this.responderPage = `https://${window.location.hostname}/responder.php`;
        }
        // override for client ID
        if(typeof options.clientId !== 'undefined' && options.clientId !== '') {
            this.clientId = options.clientId;
        } else {
            this.clientId = 'DATG-WEBABC.WEB-PROD';
        }
        // override for context
        if(typeof options.context !== 'undefined' && options.context !== '') {
            this.context = options.context;
        } else {
            this.context = 'ABC_DWTSVoting_Web';
        }
        // override for source
        if(typeof options.source !== 'undefined' && options.source !== '') {
            this.source = options.source;
        } else {
            this.source = 'DWTS_S27';
        }

        this.isMobileDevice = options.isMobileDevice;
        this.$body = $('body');
    },
    /**
     * Initialize OneID
     */
    setUpOID: function() {
        var deferred = $.Deferred();

        const langMap = {
            'en': 'en-US',
            'es': 'es-LA',
            'fr': 'fr-CA'
        };
        const lang = this.copyCms.get('language');

        this.oid = OneID.get({ // eslint-disable-line
            clientId: this.clientId,
            langPref: langMap[lang],
            responderPage: this.responderPage,
            cssOverride: this.cssOverride,
            optionalConfigs: {
                reporting: {
                    context: this.context,
                    source: this.source,
                },
                sourceName: 'DWTS Voting',
                displayOptions: {
                    darkMode: true,
                },
            },
        });

        this.oid.on('login',this.onLogin.bind(this));
        this.oid.on('logout',this.onLogout.bind(this));
        this.oid.on('create',this.onCreate.bind(this));
        this.oid.on('close',this.closeModal.bind(this));

        this.oid.init()
            .then(function(data){
                if(data.loggedIn) {
                    this.set({
                        id: data.guest.profile.swid,
                        firstName: data.guest.profile.firstName,
                        lastName: data.guest.profile.lastName,
                        username: data.guest.profile.username,
                        dateOfBirth: data.guest.profile.dateOfBirth,
                        emailVerified: data.guest.profile.emailVerified,
                        guest: data.guest,
                        loggedIn: true
                    });
                }
                deferred.resolve(data);
            }.bind(this))
            .catch( function(error) {
                console.log('OneID init error: ', error);
            });

        return deferred;
    },
    /**
     * OneID Login
     */
    login: function() {

        PubSub.trigger('omniture:state','OneID');
        this.clickedLogin = true;

        if(this.get('loggedIn') && this.get('emailVerified') === false) {
            this._verifyEmail();
        } else {
            this.oid.launchIdentityFlow();
        }

        this.promise = $.Deferred();

        this.openModal();
        return this.promise;
    },

    _verifyEmail: function() {
        return this.oid.launchEmailVerification()
            .then( function() {
                this.set({
                    'emailVerified': true
                });
                this.resolvePromise();
            }.bind(this));
    },
    /**
     * Facebook Login
     */
    fbLogin: function() {
        try {
            FB.getLoginStatus(function(response) {
                if (response.status != 'connected') {
                    FB.login(function(response) {
                        // only on successful login initiate Disney ID UI Facebook flow
                        if (response.authResponse) {
                            this.oid.facebookConnect(FB,response);
                        }
                    }, {'scope':'offline_access,email,user_birthday,user_location'});
                } else {
                    this.oid.facebookConnect(FB,response);
                }
            });
        } catch (e) {
            console.warn('one id: FB not initialized');
        }
        this.openModal();
    },
    /**
     * Login Callback
     */
    onLogin: function(data) {
        this.closeModal();

        // DV-526 - If the payload is 'reduced', then we need to ask the Guest Controller
        // for the full user profile.
        if (data.payload === 'full') {
            this.setUserData(data);
            this.resolvePromise();
        } else {
            this.oid.getGuest(true)
                .then(function(data){
                    this.setUserData(data);
                    this.resolvePromise();
                }.bind(this))
                .catch(function(error){
                    console.log('error: DID getGuest', error);
                });
        }

        if(this.clickedLogin) {
            PubSub.trigger('omniture:action', 'loginSuccess');
            this.clickedLogin = false;
        }


    },
    /**
     * Logout Callback
     */
    onLogout: function() {
        this.set(this.defaults);
        PubSub.trigger('omniture:action', 'logoutSuccess');
        this.closeModal();

        this.resolvePromise();
    },
    /**
     * Register Callback
     */
    onCreate: function(data) {
        //this event doesn't seem to be fired off

        this.setUserData( data );

        PubSub.trigger('omniture:action', 'registerSuccess');

        this.resolvePromise();
    },
    /**
     * OneID Logout
     */
    logout: function() {
        this.closeModal();
        return this.oid.logout();
    },
    /**
     * OneID Edit Profile
     */
    profile: function() {
        this.oid.launchProfile()
            .then(function(data){
                console.log('DID launchProfile',data);
            })
            .catch(function(error){
                console.log('error: DID launchProfile',error);
            });
        this.openModal();
    },
    /**
     * OneID Login Status
     */
    getLoginStatus: function(fullPayload) {
        this.oid.getGuest(fullPayload)
            .then(function(data){
                console.log('DID getLoginStatus',data, JSON.stringify(data));
                console.log('login event', data);
                this.setUserData( data );
            }.bind(this))
            .catch(function(error){
                console.log('error: DID getLoginStatus', error);
            });
    },
    /**
     * [ isConnected ]
     */
    isConnected: function() {
        return this.get('loggedIn');
    },

    isVerified: function() {
        return this.get('emailVerified');
    },
    /**
     * [ closeModal ]
     */
    closeModal: function(){
        //modal close
        this.$body.alterClass('modal-has-*', '');
        //android specific issue with rendering on modal
        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf('android') > -1; //&& ua.indexOf("mobile");
        if(isAndroid) {
            $('body .page-wrapper').hide();
            $('#disneyid-wrapper').show();
            $('#TelescopeAppDWTSModal').hide();
            window.setTimeout(function(){
                $('#disneyid-wrapper').hide();
                $('#TelescopeAppDWTSModal').show();
                $('body .page-wrapper').show();
            }, 100);
        }

        // remove the styling
        this.toggleStylingForMobile( false );

        // the oneid script adds overflow hidden to the html element but doesn't always remove it
        this.$body.parent().css( 'overflow', '' );

        var elem = $('body').find('[data-focusable]')[0];
        if (elem){
            elem.focus();
        }
    },
    /**
     * [ openModal ]
     */
    openModal: function() {
        this.$body.alterClass('modal-has-*','modal-has-view-login');
        document.activeElement.blur();
        //android specific issue with rendering on modal
        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf('android') > -1; //&& ua.indexOf("mobile");
        if(isAndroid) {
            $('body .page-wrapper').fadeOut(500);
            $('#TelescopeAppDWTSModal').fadeOut(500);
            window.setTimeout(function(){
                $('body .page-wrapper').show();
                $('#TelescopeAppDWTSModal').show();
            }, 100);
        }

        // apply the styling
        this.toggleStylingForMobile( true );
    },
    /**
     * [ toggleStylingForMobile ]
     * applies styling override so user cannot scroll when modal is open.
     */
    toggleStylingForMobile: function( bool ){
        if( !this.isMobileDevice ) return;

        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

        var height = bool ? ( window.innerHeight || document.documentElement.offsetHeight ) : '';
        var overflow = bool ? 'hidden' : '';

        this.$body.css({
            height: height,
            overflow: overflow
        });

        $('#disneyid-wrapper').css({
            overflow: iOS? 'scroll': 'initial',
            '-webkit-overflow-scrolling': 'touch'
        });
    },

    resolvePromise: function() {
        if(this.promise) {
            this.promise.resolve(this);
            this.promise = null;
        }
    },

    setUserData: function( data ) {

        this.set({
            id: data.profile.swid,
            firstName: data.profile.firstName,
            lastName: data.profile.lastName,
            username: data.profile.username,
            dateOfBirth: data.profile.dateOfBirth,
            emailVerified: data.profile.emailVerified,
            guest: data,
            loggedIn: true
        });

    }
});



// WEBPACK FOOTER //
// ./app/scripts/models/oneid.js